import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import {
  DeleteOutlined, EditOutlined,
  MoreOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { Avatar, Button, ColorPicker, Dropdown, Form, Input, Modal, Skeleton } from 'antd';
import {
  useCreateEpicMutation,
  useDeleteEpicMutation, useEpicsQuery, useUpdateEpicMutation
} from 'generated/graphql';
import _, { isString } from 'lodash';
import { observer } from 'mobx-react-lite';
import { Store } from 'model/store/Store';

import { Page } from '../../../components/Page/Page';
import { presets, random } from '../../../config/colors';

import cls from './Groups.module.scss';

export const Groups = observer(() => {

  const { domain } = useInstance(Store);
  const { t } = useTranslation();

  const [modal, contextHolder] = Modal.useModal();
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm()

  const groups = useEpicsQuery({
    variables: {
      filters: {
        domain: {id: {eq: domain.selectedDomain}},
      },
      pagination: { limit: 100 }
    }
  });

  const [deleteEpic] = useDeleteEpicMutation()
  const [updateEpic] = useUpdateEpicMutation()
  const [createEpic] = useCreateEpicMutation()
  const onDeleteGroup = async (id: string) => {
    await deleteEpic({
      variables: { id: id },
      onCompleted: () => {
        groups.refetch();
      }
    });
  };

  const onClose = () => {
    setOpen(false)
    // form.resetFields()
  }

  const onFinish = async () => {
    const data = {
      id: form.getFieldValue('id'),
      name: form.getFieldValue('name'),
      color: isString(form.getFieldValue('color')) ? form.getFieldValue('color') : form.getFieldValue('color').toHexString() ,
    }
    if (data.id) {
      await updateEpic ({
        variables: {
          id: data.id,
          data: {
            name: data.name,
            color: data.color,
          }
        },
        onCompleted: () => {
          groups.refetch()
          setOpen(false)
        }
      })
    } else {
      await createEpic ({
        variables: {
          data: {
            name: data.name,
            color: data.color,
            domain: domain.selectedDomain,
          }
        },
        onCompleted: () => {
          groups.refetch()
          setOpen(false)
        }
      })

    }
  }

  return (
    <Page name={t('Groups')!}>
      <Page.Content>

        {groups.loading && <Skeleton active />}

      </Page.Content>

      {_.map(groups.data?.epics?.data, (group, index) => (
        <React.Fragment key={group.id}>
          <Page.Content>
            <div className={cls.row}>

              <div className={cls.number}>{index + 1}</div>

              <div className={cls.name}>
                <Avatar size={'small'} style={{ backgroundColor: group.attributes?.color! }}/> {group.attributes?.name}
              </div>

              <div className={cls.control}>
                <Dropdown menu={{
                  items: [
                    {
                      key: 'edit',
                      label: t('Edit'),
                      icon: <EditOutlined/>,
                      onClick: () => {
                        form.setFieldValue('id', group.id)
                        form.setFieldValue('name', group.attributes?.name)
                        form.setFieldValue('color', group.attributes?.color)
                        setOpen(true)
                      },
                    },
                    {
                      key: 'delete',
                      label: t('Delete'),
                      icon: <DeleteOutlined/>,
                      danger: true,
                      onClick: async () => {
                        const confirmed = await modal.confirm({
                          title: t('Delete Group'),
                          content: t('Are you sure to delete Group {{name}}?', { name: group.attributes?.name })
                        });
                        if (confirmed) {
                          onDeleteGroup(group.id!);
                        }
                      }

                    },]
                }} trigger={['click']}>
                  <Button type={'text'} icon={<MoreOutlined />} />
                </Dropdown>
              </div>

            </div>
          </Page.Content>
          <Page.Divider />
        </React.Fragment>
      ))}

      <Page.Content>
        <Button shape={'circle'} icon={<PlusOutlined />} className={cls.plus} onClick={() => {
            // form.setFieldValue('id', 'new')
            // form.setFieldValue('name', '')
            // form.setFieldValue('color', '')
            form.resetFields()
            setOpen(true)
        }} />
      </Page.Content>
      <Page.Divider />

      {contextHolder}

      <Modal open={open} onCancel={onClose} footer={null} closable={false} width={360}>
        <Form layout={'inline'} onFinish={onFinish} form={form}>
          <Form.Item name={'name'}
                     rules={[
                       {
                         required: true,
                         message: t('Please enter the data') || '',
                       },
                     ]}
                     initialValue={''}
          >
            <Input bordered={false} placeholder={t('New Group')!} style={{width: 148}}/>
          </Form.Item>
          <Form.Item name={'color'} initialValue={random()}
                     rules={[
                       {
                         required: true,
                         message: t('Please enter the data') || '',
                       },
                     ]}
          >
            <ColorPicker presets={presets} panelRender={(_, {components: {Presets}}) => <Presets />}/>
          </Form.Item>
          <Form.Item>
            {!form.getFieldValue('id') ?
              <Button htmlType={'submit'} icon={<PlusOutlined />}>{t('Add')}</Button>
              :
              <Button htmlType={'submit'}>{t('Save')}</Button>
            }
          </Form.Item>
        </Form>

      </Modal>

    </Page>
  );

});


